// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --bg:#EFF0EC;
  --surface:#F7F5F1;
  --surface-strong:#FFFFFF;
  --text:#13231D;
  --muted:rgba(19,35,29,.74);
  --soft-muted:rgba(19,35,29,.48);
  --border:rgba(16,25,21,.10);
  --primary:#82B194;
  --primary-dark:#5E806C;
  --shadow:0 18px 48px rgba(16,25,21,.06);
}

.WelcomeOnboardingPage_welcome-page-container__Uuj8Q {
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
  background: var(--bg);
  color: var(--text);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 20px;
  position: relative;
}

.WelcomeOnboardingPage_welcome-page-container__Uuj8Q * {
  box-sizing: border-box;
}

.WelcomeOnboardingPage_welcome-page-container__Uuj8Q a {
  text-decoration: none;
  color: inherit;
}

.WelcomeOnboardingPage_utility-bar__BQom\\+ {
  position: absolute;
  top: 16px;
  left: 18px;
  z-index: 12;
}

.WelcomeOnboardingPage_back__Db7aA {
  display: inline-grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  border: 1px solid rgba(16, 25, 21, 0.12);
  color: rgba(19, 35, 29, 0.46);
  background: rgba(255, 255, 255, 0.56);
  font-size: 16px;
}

.WelcomeOnboardingPage_example-shell__LmyiN {
  position: relative;
  width: min(930px, 100%);
}

.WelcomeOnboardingPage_example-grid__51pQQ {
  display: grid;
  grid-template-columns: minmax(0, 390px) 405px;
  gap: 18px;
  justify-content: center;
  align-items: start;
}

.WelcomeOnboardingPage_welcome-pane__Ezwm0 {
  min-height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 0;
}

.WelcomeOnboardingPage_welcome-copy__zlz5d {
  width: min(390px, 100%);
  padding-top: 22px;
}

.WelcomeOnboardingPage_welcome-logo__dYV8E {
  display: block;
  width: 160px;
  height: auto;
  margin: 0 0 16px;
}

.WelcomeOnboardingPage_welcome-copy__zlz5d .WelcomeOnboardingPage_eyebrow__dahyS {
  margin: 0 0 12px;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--primary-dark);
}

.WelcomeOnboardingPage_welcome-copy__zlz5d h2 {
  margin: 0 0 14px;
  font-size: 54px;
  line-height: 0.98;
  letter-spacing: -0.05em;
  color: #13231D;
}

.WelcomeOnboardingPage_welcome-copy__zlz5d p {
  margin: 0 0 12px;
  font-size: 18px;
  line-height: 1.58;
  color: var(--muted);
}

.WelcomeOnboardingPage_steps__tqJVN {
  margin: 18px 0 0;
  display: grid;
  gap: 10px;
}

.WelcomeOnboardingPage_step__Rm-yK {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;
  line-height: 1.58;
  color: var(--muted);
}

.WelcomeOnboardingPage_step__Rm-yK .WelcomeOnboardingPage_n__nyRH1 {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  background: rgba(130, 177, 148, 0.12);
  color: var(--primary-dark);
  font-size: 14px;
  font-weight: 800;
  flex: 0 0 30px;
}

.WelcomeOnboardingPage_replay-link__nfkRm {
  display: inline-flex;
  margin-top: 18px;
  color: var(--primary-dark);
  font-size: 14px;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 4px;
  text-decoration-thickness: 1px;
}

.WelcomeOnboardingPage_replay-link__nfkRm:hover {
  color: var(--text);
}

.WelcomeOnboardingPage_form-card__7ctJF {
  align-self: start;
  background: var(--surface);
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 30px;
  padding: 20px 22px 16px;
  box-shadow: 0 14px 40px rgba(16, 25, 21, 0.04);
}

.WelcomeOnboardingPage_tabs__5XiJ6 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid rgba(16, 25, 21, 0.12);
  margin-bottom: 10px;
}

.WelcomeOnboardingPage_tab__7z2Qn {
  padding: 10px 0 12px;
  text-align: center;
  color: rgba(19, 35, 29, 0.64);
  font-size: 14px;
}

.WelcomeOnboardingPage_tab__7z2Qn.WelcomeOnboardingPage_active__iF8il {
  color: #3D4642;
  font-weight: 700;
  border-bottom: 2px solid var(--primary);
  margin-bottom: -1px;
}

.WelcomeOnboardingPage_fields__pw\\+aZ {
  display: grid;
  gap: 10px;
}

.WelcomeOnboardingPage_field__WNc6t, .WelcomeOnboardingPage_switch-field__agH10 {
  min-height: 42px;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 14px;
  background: var(--surface-strong);
  display: flex;
  align-items: center;
  padding: 0 14px;
  font-size: 14px;
  color: rgba(19, 35, 29, 0.42);
}

.WelcomeOnboardingPage_field-input__m3EqP {
  min-height: 42px;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 14px;
  background: var(--surface-strong);
  display: flex;
  align-items: center;
  padding: 0 14px;
  font-size: 14px;
  color: var(--text);
  width: 100%;
}

.WelcomeOnboardingPage_field-input__m3EqP:focus {
  outline: none;
  border-color: rgba(130, 177, 148, 0.52);
  box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.09);
}

.WelcomeOnboardingPage_field-input__m3EqP:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #FFFFFF inset !important;
  -webkit-text-fill-color: #13231D !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

.WelcomeOnboardingPage_field-input__m3EqP:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px #E6EBE4 inset !important;
  -webkit-text-fill-color: #13231D !important;
}

.WelcomeOnboardingPage_field-disabled__kjB1w {
  min-height: 42px;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 14px;
  background: #EBEBEB;
  display: flex;
  align-items: center;
  padding: 0 14px;
  font-size: 14px;
  color: rgba(19, 35, 29, 0.52);
}

.WelcomeOnboardingPage_field__WNc6t.WelcomeOnboardingPage_active__iF8il {
  border-color: rgba(130, 177, 148, 0.52);
  background: rgba(130, 177, 148, 0.08);
  box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.09);
}

.WelcomeOnboardingPage_switch-field__agH10 {
  justify-content: flex-start;
  gap: 10px;
  color: #3D4642;
}

.WelcomeOnboardingPage_switch__IqSvD {
  width: 24px;
  height: 14px;
  border-radius: 999px;
  background: #D7DDD9;
  position: relative;
  flex: 0 0 24px;
}

.WelcomeOnboardingPage_switch__IqSvD:after {
  content: "";
  position: absolute;
  left: 2px;
  top: 2px;
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

.WelcomeOnboardingPage_switch-on__mbR52 {
  background: var(--primary);
}

.WelcomeOnboardingPage_switch-on__mbR52:after {
  left: auto;
  right: 2px;
}

.WelcomeOnboardingPage_checks__aO3lg {
  display: grid;
  gap: 10px;
  margin-top: 12px;
}

.WelcomeOnboardingPage_check__LQlqL {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(19, 35, 29, 0.54);
}

.WelcomeOnboardingPage_box__ZhzSW {
  width: 14px;
  height: 14px;
  border: 1px solid rgba(16, 25, 21, 0.18);
  background: #F6F7F5;
  flex: 0 0 14px;
  margin-top: 1px;
  position: relative;
}

.WelcomeOnboardingPage_box-checked__Yvy4T {
  background: var(--primary);
  border-color: var(--primary);
}

.WelcomeOnboardingPage_box-checked__Yvy4T:after {
  content: "✓";
  position: absolute;
  color: white;
  font-size: 10px;
  left: 2px;
  top: -1px;
}

.WelcomeOnboardingPage_check__LQlqL a, .WelcomeOnboardingPage_legal-note__4XIEY a {
  color: #739F84;
}

.WelcomeOnboardingPage_primary__av2tH, .WelcomeOnboardingPage_google__55nR- {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  border-radius: 14px;
}

.WelcomeOnboardingPage_primary__av2tH {
  margin-top: 14px;
  background: var(--primary);
  color: #fff;
  font-weight: 800;
  font-size: 14px;
}

.WelcomeOnboardingPage_primary__av2tH:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.WelcomeOnboardingPage_divider__6dD7O {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 0 10px;
  color: #9AA39F;
  font-size: 11px;
  text-transform: lowercase;
}

.WelcomeOnboardingPage_divider__6dD7O:before, .WelcomeOnboardingPage_divider__6dD7O:after {
  content: "";
  height: 1px;
  background: rgba(16, 25, 21, 0.12);
  flex: 1 1;
}

.WelcomeOnboardingPage_google__55nR- {
  gap: 10px;
  border: 1px solid rgba(16, 25, 21, 0.12);
  background: var(--surface);
  font-weight: 600;
  color: #13231D;
}

.WelcomeOnboardingPage_gmark__Pr92z {
  font-weight: 900;
  font-size: 18px;
  color: #4285F4;
}

.WelcomeOnboardingPage_go-home__ePd97 {
  display: flex;
  justify-content: center;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #6B9C7C;
}

.WelcomeOnboardingPage_legal-note__4XIEY {
  margin: 12px 0 0;
  text-align: center;
  font-size: 10px;
  line-height: 1.45;
  color: rgba(19, 35, 29, 0.46);
}

/* Video modal styles */
.WelcomeOnboardingPage_video-modal__wKZju {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  background: rgba(19, 35, 29, 0.18);
  backdrop-filter: blur(5px);
  z-index: 100;
}

.WelcomeOnboardingPage_video-card__jpP56 {
  position: relative;
  width: fit-content;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  border-radius: 24px;
  background: var(--surface);
  border: 1px solid rgba(16, 25, 21, 0.08);
  box-shadow: 0 30px 80px rgba(16, 25, 21, 0.16);
  padding: 10px 8px 12px;
  display: flex;
  flex-direction: column;
  overflow: visible;
}

.WelcomeOnboardingPage_video-top__du3\\+g {
  display: block;
  height: 0;
  margin: 0;
}

.WelcomeOnboardingPage_close-video__7LfLX {
  position: absolute;
  top: -14px;
  right: -14px;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 999px;
  background: var(--surface);
  border: 1px solid rgba(16, 25, 21, 0.08);
  color: var(--primary-dark);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: grid;
  place-items: center;
  padding: 0;
  box-shadow: 0 10px 24px rgba(16, 25, 21, 0.1);
  z-index: 10;
}

.WelcomeOnboardingPage_video-wrap__ie1mJ {
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background: #000;
  aspect-ratio: 9/16;
  margin: 0 auto;
  width: min(348px, 39.375vh);
  max-width: 100%;
}

.WelcomeOnboardingPage_video-wrap__ie1mJ video {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.WelcomeOnboardingPage_video-note__x4AVx {
  margin: 8px 4px 0;
  text-align: center;
  font-size: 12px;
  line-height: 1.45;
  color: #40524A;
}

.WelcomeOnboardingPage_audio-tip__NUlK8 {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  color: rgba(19, 35, 29, 0.52);
}

.WelcomeOnboardingPage_video-overlay__N2uVO {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to top, rgba(19, 35, 29, 0.18), rgba(19, 35, 29, 0) 42%);
  pointer-events: auto;
}

.WelcomeOnboardingPage_play-btn__q4amT {
  width: 58px;
  height: 58px;
  border: none;
  border-radius: 999px;
  background: rgba(247, 245, 241, 0.92);
  box-shadow: 0 10px 24px rgba(16, 25, 21, 0.14);
  display: grid;
  place-items: center;
  cursor: pointer;
  pointer-events: auto;
}

.WelcomeOnboardingPage_play-btn__q4amT:before {
  content: "";
  margin-left: 3px;
  border-left: 15px solid var(--primary-dark);
  border-top: 9px solid transparent;
  border-bottom: 9px solid transparent;
}

.WelcomeOnboardingPage_video-controls__mwjZ6 {
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(19, 35, 29, 0.58);
  backdrop-filter: blur(8px);
}

.WelcomeOnboardingPage_ctrl-btn__OVkps {
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  display: grid;
  place-items: center;
  cursor: pointer;
  padding: 0;
  flex: 0 0 30px;
}

.WelcomeOnboardingPage_ctrl-btn__OVkps.WelcomeOnboardingPage_playing__hvSEL::before {
  content: "❚❚";
  font-size: 11px;
  letter-spacing: -2px;
}

.WelcomeOnboardingPage_ctrl-btn__OVkps.WelcomeOnboardingPage_paused__WK8RF::before {
  content: "▶";
  font-size: 13px;
  margin-left: 2px;
}

.WelcomeOnboardingPage_ctrl-btn__OVkps.WelcomeOnboardingPage_volume-on__bQGLP::before {
  content: "🔊";
  font-size: 13px;
}

.WelcomeOnboardingPage_ctrl-btn__OVkps.WelcomeOnboardingPage_volume-off__DnZbF::before {
  content: "🔇";
  font-size: 13px;
}

.WelcomeOnboardingPage_progress-range__Tzt1U, .WelcomeOnboardingPage_volume-range__CQ4QB {
  appearance: none;
  height: 4px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.28);
  outline: none;
  min-width: 0;
}

.WelcomeOnboardingPage_progress-range__Tzt1U {
  flex: 1 1;
}

.WelcomeOnboardingPage_volume-range__CQ4QB {
  width: 72px;
  max-width: 30%;
}

.WelcomeOnboardingPage_progress-range__Tzt1U::-webkit-slider-thumb, .WelcomeOnboardingPage_volume-range__CQ4QB::-webkit-slider-thumb {
  appearance: none;
  width: 12px;
  height: 12px;
  border-radius: 999px;
  background: #fff;
  cursor: pointer;
}

.WelcomeOnboardingPage_progress-range__Tzt1U::-moz-range-thumb, .WelcomeOnboardingPage_volume-range__CQ4QB::-moz-range-thumb {
  width: 12px;
  height: 12px;
  border: none;
  border-radius: 999px;
  background: #fff;
  cursor: pointer;
}

@media (max-width: 1120px) {
  .WelcomeOnboardingPage_example-grid__51pQQ {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  .WelcomeOnboardingPage_welcome-pane__Ezwm0 {
    justify-content: flex-start;
  }
  .WelcomeOnboardingPage_welcome-copy__zlz5d {
    width: min(520px, 100%);
  }
  .WelcomeOnboardingPage_welcome-copy__zlz5d h2 {
    font-size: 48px;
  }
  .WelcomeOnboardingPage_form-card__7ctJF {
    max-width: 440px;
    margin: 0 auto;
  }
}
@media (max-width: 760px) {
  .WelcomeOnboardingPage_welcome-page-container__Uuj8Q {
    padding: 56px 16px 24px;
  }
  .WelcomeOnboardingPage_welcome-copy__zlz5d h2 {
    font-size: 38px;
  }
  .WelcomeOnboardingPage_welcome-copy__zlz5d p {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/WelcomeOnboardingPage/WelcomeOnboardingPage.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,YAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;EACA,0BAAA;EACA,+BAAA;EACA,2BAAA;EACA,iBAAA;EACA,sBAAA;EACA,uCAAA;AAEF;;AACA;EACE,oFAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAEF;;AACA;EACE,sBAAA;AAEF;;AACA;EACE,qBAAA;EACA,cAAA;AAEF;;AACA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AAEF;;AACA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,wCAAA;EACA,6BAAA;EACA,qCAAA;EACA,eAAA;AAEF;;AACA;EACE,kBAAA;EACA,uBAAA;AAEF;;AACA;EACE,aAAA;EACA,6CAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;AAEF;;AACA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,UAAA;AAEF;;AACA;EACE,uBAAA;EACA,iBAAA;AAEF;;AACA;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAEF;;AACA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,0BAAA;AAEF;;AACA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAEF;;AACA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAEF;;AACA;EACE,gBAAA;EACA,aAAA;EACA,SAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,qCAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAEF;;AACA;EACE,oBAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;AAEF;;AAAA;EAAoB,kBAAA;AAIpB;;AAFA;EACE,iBAAA;EACA,0BAAA;EACA,wCAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;AAKF;;AAFA;EACE,aAAA;EACA,8BAAA;EACA,+CAAA;EACA,mBAAA;AAKF;;AAFA;EACE,oBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;AAKF;;AAHA;EACE,cAAA;EACA,gBAAA;EACA,uCAAA;EACA,mBAAA;AAMF;;AAHA;EAAU,aAAA;EAAc,SAAA;AAQxB;;AANA;EACE,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,6BAAA;AASF;;AAPA;EACE,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AAUF;;AARA;EACE,aAAA;EACA,uCAAA;EACA,+CAAA;AAWF;;AATA;EACE,yDAAA;EACA,2CAAA;EACA,yDAAA;EAAA,iDAAA;AAYF;;AAVA;EACE,yDAAA;EACA,2CAAA;AAaF;;AAXA;EACE,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,6BAAA;AAcF;;AAZA;EACE,uCAAA;EACA,qCAAA;EACA,+CAAA;AAeF;;AAZA;EAAgB,2BAAA;EAA4B,SAAA;EAAU,cAAA;AAkBtD;;AAjBA;EACE,WAAA;EAAW,YAAA;EAAY,oBAAA;EAAoB,mBAAA;EAAmB,kBAAA;EAAkB,cAAA;AAyBlF;;AAvBA;EACE,WAAA;EAAW,kBAAA;EAAkB,SAAA;EAAS,QAAA;EAAQ,WAAA;EAAW,YAAA;EAAY,oBAAA;EAAoB,gBAAA;EAAgB,yCAAA;AAkC3G;;AAhCA;EAAa,0BAAA;AAoCb;;AAnCA;EAAmB,UAAA;EAAY,UAAA;AAwC/B;;AAtCA;EAAU,aAAA;EAAc,SAAA;EAAU,gBAAA;AA4ClC;;AA3CA;EACE,aAAA;EAAc,uBAAA;EAAwB,SAAA;EAAU,eAAA;EAAgB,gBAAA;EAAiB,6BAAA;AAmDnF;;AAjDA;EAAO,WAAA;EAAY,YAAA;EAAa,wCAAA;EAAqC,mBAAA;EAAoB,cAAA;EAAe,eAAA;EAAgB,kBAAA;AA2DxH;;AA1DA;EAAe,0BAAA;EAA4B,4BAAA;AA+D3C;;AA9DA;EAAqB,YAAA;EAAa,kBAAA;EAAmB,YAAA;EAAa,eAAA;EAAgB,SAAA;EAAU,SAAA;AAuE5F;;AAtEA;EAA0B,cAAA;AA0E1B;;AAxEA;EAAoB,aAAA;EAAc,mBAAA;EAAoB,uBAAA;EAAwB,gBAAA;EAAiB,mBAAA;AAgF/F;;AA/EA;EAAW,gBAAA;EAAiB,0BAAA;EAA2B,WAAA;EAAY,gBAAA;EAAiB,eAAA;AAuFpF;;AAtFA;EAAoB,YAAA;EAAc,mBAAA;AA2FlC;;AAzFA;EAAW,aAAA;EAAc,mBAAA;EAAoB,SAAA;EAAU,mBAAA;EAAoB,cAAA;EAAe,eAAA;EAAgB,yBAAA;AAmG1G;;AAlGA;EAAkC,WAAA;EAAY,WAAA;EAAY,kCAAA;EAA+B,SAAA;AAyGzF;;AAvGA;EAAU,SAAA;EAAU,wCAAA;EAAqC,0BAAA;EAA2B,gBAAA;EAAiB,cAAA;AA+GrG;;AA9GA;EAAS,gBAAA;EAAiB,eAAA;EAAgB,cAAA;AAoH1C;;AAlHA;EAAW,aAAA;EAAc,uBAAA;EAAwB,eAAA;EAAgB,eAAA;EAAgB,gBAAA;EAAiB,cAAA;AA2HlG;;AAzHA;EAAc,gBAAA;EAAiB,kBAAA;EAAmB,eAAA;EAAgB,iBAAA;EAAkB,6BAAA;AAiIpF;;AA/HA,uBAAA;AACA;EACE,eAAA;EAAgB,QAAA;EAAS,aAAA;EAAc,mBAAA;EAAoB,uBAAA;EAAwB,aAAA;EACnF,kCAAA;EAA+B,0BAAA;EAA2B,YAAA;AAyI5D;;AAvIA;EACE,kBAAA;EAAmB,kBAAA;EAAmB,6BAAA;EAA8B,8BAAA;EAA+B,mBAAA;EAAoB,0BAAA;EAA2B,wCAAA;EAClJ,8CAAA;EAA2C,sBAAA;EAAuB,aAAA;EAAc,sBAAA;EAAuB,iBAAA;AAoJzG;;AAlJA;EAAa,cAAA;EAAe,SAAA;EAAU,SAAA;AAwJtC;;AAvJA;EACE,kBAAA;EAAmB,UAAA;EAAW,YAAA;EAAa,WAAA;EAAY,YAAA;EAAa,YAAA;EAAa,oBAAA;EAAqB,0BAAA;EAA2B,wCAAA;EAAqC,0BAAA;EAA2B,eAAA;EAAgB,cAAA;EAAe,eAAA;EAAgB,aAAA;EAAc,mBAAA;EAAoB,UAAA;EAAW,6CAAA;EAA2C,WAAA;AA2K1U;;AAzKA;EAAc,kBAAA;EAAmB,gBAAA;EAAiB,mBAAA;EAAoB,gBAAA;EAAiB,kBAAA;EAAmB,cAAA;EAAe,2BAAA;EAAuC,eAAA;AAoLhK;;AAnLA;EAAoB,WAAA;EAAY,YAAA;EAAa,cAAA;EAAe,iBAAA;AA0L5D;;AAzLA;EAAc,iBAAA;EAAkB,kBAAA;EAAmB,eAAA;EAAgB,iBAAA;EAAkB,cAAA;AAiMrF;;AAhMA;EAAa,cAAA;EAAe,eAAA;EAAgB,eAAA;EAAgB,6BAAA;AAuM5D;;AArMA;EAAiB,kBAAA;EAAmB,QAAA;EAAS,aAAA;EAAc,mBAAA;EAAoB,uBAAA;EAAwB,oFAAA;EAA8E,oBAAA;AA+MrL;;AA9MA;EAAY,WAAA;EAAY,YAAA;EAAa,YAAA;EAAa,oBAAA;EAAqB,qCAAA;EAAkC,8CAAA;EAA2C,aAAA;EAAc,mBAAA;EAAoB,eAAA;EAAgB,oBAAA;AA2NtM;;AA1NA;EAAmB,WAAA;EAAY,gBAAA;EAAiB,2CAAA;EAA4C,iCAAA;EAAkC,oCAAA;AAkO9H;;AAhOA;EAAkB,kBAAA;EAAmB,UAAA;EAAW,WAAA;EAAY,YAAA;EAAa,aAAA;EAAc,mBAAA;EAAoB,SAAA;EAAU,kBAAA;EAAmB,mBAAA;EAAoB,kCAAA;EAA+B,0BAAA;AA8O3L;;AA7OA;EAAY,WAAA;EAAY,YAAA;EAAa,YAAA;EAAa,oBAAA;EAAqB,qCAAA;EAAkC,WAAA;EAAY,aAAA;EAAc,mBAAA;EAAoB,eAAA;EAAgB,UAAA;EAAW,cAAA;AA2PlL;;AA1PA;EAA4B,aAAA;EAAc,eAAA;EAAgB,oBAAA;AAgQ1D;;AA/PA;EAA2B,YAAA;EAAa,eAAA;EAAgB,gBAAA;AAqQxD;;AApQA;EAA8B,aAAA;EAAc,eAAA;AAyQ5C;;AAxQA;EAA+B,aAAA;EAAc,eAAA;AA6Q7C;;AA3QA;EAA0D,gBAAA;EAAiB,WAAA;EAAY,oBAAA;EAAqB,qCAAA;EAAkC,aAAA;EAAc,YAAA;AAqR5J;;AApRA;EAAkB,SAAA;AAwRlB;;AAvRA;EAAgB,WAAA;EAAY,cAAA;AA4R5B;;AA3RA;EAAsG,gBAAA;EAAiB,WAAA;EAAY,YAAA;EAAa,oBAAA;EAAqB,gBAAA;EAAiB,eAAA;AAqStL;;AApSA;EAAqE,WAAA;EAAY,YAAA;EAAa,YAAA;EAAa,oBAAA;EAAqB,gBAAA;EAAiB,eAAA;AA6SjJ;;AA3SA;EACE;IAAgB,0BAAA;IAA2B,SAAA;EAgT3C;EA/SA;IAAgB,2BAAA;EAkThB;EAjTA;IAAgB,uBAAA;EAoThB;EAnTA;IAAmB,eAAA;EAsTnB;EArTA;IAAa,gBAAA;IAAiB,cAAA;EAyT9B;AACF;AAxTA;EACE;IAA0B,uBAAA;EA2T1B;EA1TA;IAAmB,eAAA;EA6TnB;EA5TA;IAAkB,eAAA;EA+TlB;AACF","sourcesContent":[":root{\n  --bg:#EFF0EC;\n  --surface:#F7F5F1;\n  --surface-strong:#FFFFFF;\n  --text:#13231D;\n  --muted:rgba(19,35,29,.74);\n  --soft-muted:rgba(19,35,29,.48);\n  --border:rgba(16,25,21,.10);\n  --primary:#82B194;\n  --primary-dark:#5E806C;\n  --shadow:0 18px 48px rgba(16,25,21,.06);\n}\n\n.welcome-page-container {\n  font-family:\"Sora\",system-ui,-apple-system,\"Segoe UI\",Roboto,Arial,sans-serif;\n  background:var(--bg);\n  color:var(--text);\n  min-height:100vh;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  padding:18px 20px;\n  position: relative;\n}\n\n.welcome-page-container * {\n  box-sizing:border-box;\n}\n\n.welcome-page-container a {\n  text-decoration:none;\n  color:inherit;\n}\n\n.utility-bar {\n  position:absolute;\n  top:16px;\n  left:18px;\n  z-index:12;\n}\n\n.back {\n  display:inline-grid;\n  place-items:center;\n  width:30px;\n  height:30px;\n  border-radius:999px;\n  border:1px solid rgba(16,25,21,.12);\n  color:rgba(19,35,29,.46);\n  background:rgba(255,255,255,.56);\n  font-size:16px;\n}\n\n.example-shell {\n  position:relative;\n  width:min(930px, 100%);\n}\n\n.example-grid {\n  display:grid;\n  grid-template-columns:minmax(0,390px) 405px;\n  gap:18px;\n  justify-content:center;\n  align-items:start;\n}\n\n.welcome-pane {\n  min-height:auto;\n  display:flex;\n  align-items:flex-start;\n  justify-content:flex-end;\n  padding:0;\n}\n\n.welcome-copy {\n  width:min(390px,100%);\n  padding-top:22px;\n}\n\n.welcome-logo {\n  display:block;\n  width:160px;\n  height:auto;\n  margin:0 0 16px;\n}\n\n.welcome-copy .eyebrow {\n  margin:0 0 12px;\n  font-size:12px;\n  line-height:1.2;\n  font-weight:800;\n  letter-spacing:.16em;\n  text-transform:uppercase;\n  color:var(--primary-dark);\n}\n\n.welcome-copy h2 {\n  margin:0 0 14px;\n  font-size:54px;\n  line-height:.98;\n  letter-spacing:-.05em;\n  color:#13231D;\n}\n\n.welcome-copy p {\n  margin:0 0 12px;\n  font-size:18px;\n  line-height:1.58;\n  color:var(--muted);\n}\n\n.steps {\n  margin:18px 0 0;\n  display:grid;\n  gap:10px;\n}\n\n.step {\n  display:flex;\n  align-items:flex-start;\n  gap:12px;\n  font-size:14px;\n  line-height:1.58;\n  color:var(--muted);\n}\n\n.step .n {\n  display:grid;\n  place-items:center;\n  width:30px;\n  height:30px;\n  border-radius:999px;\n  background:rgba(130,177,148,.12);\n  color:var(--primary-dark);\n  font-size:14px;\n  font-weight:800;\n  flex:0 0 30px;\n}\n\n.replay-link {\n  display:inline-flex;\n  margin-top:18px;\n  color:var(--primary-dark);\n  font-size:14px;\n  font-weight:700;\n  text-decoration:underline;\n  text-underline-offset:4px;\n  text-decoration-thickness:1px;\n}\n.replay-link:hover {color:var(--text)}\n\n.form-card {\n  align-self:start;\n  background:var(--surface);\n  border:1px solid rgba(12,36,28,.08);\n  border-radius:30px;\n  padding:20px 22px 16px;\n  box-shadow:0 14px 40px rgba(16,25,21,.04);\n}\n\n.tabs {\n  display:grid;\n  grid-template-columns:1fr 1fr;\n  border-bottom:1px solid rgba(16,25,21,.12);\n  margin-bottom:10px;\n}\n\n.tab {\n  padding:10px 0 12px;\n  text-align:center;\n  color:rgba(19,35,29,.64);\n  font-size:14px;\n}\n.tab.active {\n  color:#3D4642;\n  font-weight:700;\n  border-bottom:2px solid var(--primary);\n  margin-bottom:-1px;\n}\n\n.fields { display:grid; gap:10px; }\n\n.field, .switch-field {\n  min-height:42px;\n  border:1px solid rgba(12,36,28,.08);\n  border-radius:14px;\n  background:var(--surface-strong);\n  display:flex;\n  align-items:center;\n  padding:0 14px;\n  font-size:14px;\n  color:rgba(19,35,29,.42);\n}\n.field-input {\n  min-height:42px;\n  border:1px solid rgba(12,36,28,.08);\n  border-radius:14px;\n  background:var(--surface-strong);\n  display:flex;\n  align-items:center;\n  padding:0 14px;\n  font-size:14px;\n  color:var(--text);\n  width: 100%;\n}\n.field-input:focus {\n  outline: none;\n  border-color:rgba(130,177,148,.52);\n  box-shadow:0 0 0 3px rgba(130,177,148,.09);\n}\n.field-input:-webkit-autofill {\n  -webkit-box-shadow: 0 0 0 1000px #FFFFFF inset !important;\n  -webkit-text-fill-color: #13231D !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n.field-input:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0 1000px #E6EBE4 inset !important;\n  -webkit-text-fill-color: #13231D !important;\n}\n.field-disabled {\n  min-height:42px;\n  border:1px solid rgba(12,36,28,.08);\n  border-radius:14px;\n  background:#EBEBEB;\n  display:flex;\n  align-items:center;\n  padding:0 14px;\n  font-size:14px;\n  color:rgba(19,35,29,.52);\n}\n.field.active {\n  border-color:rgba(130,177,148,.52);\n  background:rgba(130,177,148,.08);\n  box-shadow:0 0 0 3px rgba(130,177,148,.09);\n}\n\n.switch-field { justify-content:flex-start; gap:10px; color:#3D4642; }\n.switch {\n  width:24px;height:14px;border-radius:999px;background:#D7DDD9;position:relative;flex:0 0 24px;\n}\n.switch:after {\n  content:\"\";position:absolute;left:2px;top:2px;width:10px;height:10px;border-radius:999px;background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.12);\n}\n.switch-on { background: var(--primary); }\n.switch-on:after { left: auto; right: 2px; }\n\n.checks { display:grid; gap:10px; margin-top:12px; }\n.check {\n  display:flex; align-items:flex-start; gap:10px; font-size:12px; line-height:1.5; color:rgba(19,35,29,.54);\n}\n.box { width:14px; height:14px; border:1px solid rgba(16,25,21,.18); background:#F6F7F5; flex:0 0 14px; margin-top:1px; position:relative; }\n.box-checked { background: var(--primary); border-color: var(--primary); }\n.box-checked:after { content:\"✓\"; position:absolute; color:white; font-size:10px; left:2px; top:-1px; }\n.check a, .legal-note a { color:#739F84; }\n\n.primary, .google { display:flex; align-items:center; justify-content:center; min-height:42px; border-radius:14px; }\n.primary { margin-top:14px; background:var(--primary); color:#fff; font-weight:800; font-size:14px; }\n.primary:disabled { opacity: 0.7; cursor: not-allowed; }\n\n.divider { display:flex; align-items:center; gap:10px; margin:12px 0 10px; color:#9AA39F; font-size:11px; text-transform:lowercase; }\n.divider:before, .divider:after { content:\"\"; height:1px; background:rgba(16,25,21,.12); flex:1; }\n\n.google { gap:10px; border:1px solid rgba(16,25,21,.12); background:var(--surface); font-weight:600; color:#13231D; }\n.gmark { font-weight:900; font-size:18px; color:#4285F4; }\n\n.go-home { display:flex; justify-content:center; margin-top:8px; font-size:12px; font-weight:700; color:#6B9C7C; }\n\n.legal-note { margin:12px 0 0; text-align:center; font-size:10px; line-height:1.45; color:rgba(19,35,29,.46); }\n\n/* Video modal styles */\n.video-modal {\n  position:fixed; inset:0; display:flex; align-items:center; justify-content:center; padding:14px;\n  background:rgba(19,35,29,.18); backdrop-filter:blur(5px); z-index:100;\n}\n.video-card {\n  position:relative; width:fit-content; max-width:calc(100vw - 32px); max-height:calc(100vh - 32px); border-radius:24px; background:var(--surface); border:1px solid rgba(16,25,21,.08);\n  box-shadow:0 30px 80px rgba(16,25,21,.16); padding:10px 8px 12px; display:flex; flex-direction:column; overflow:visible;\n}\n.video-top { display:block; height:0; margin:0; }\n.close-video {\n  position:absolute; top:-14px; right:-14px; width:34px; height:34px; border:none; border-radius:999px; background:var(--surface); border:1px solid rgba(16,25,21,.08); color:var(--primary-dark); font-size:20px; line-height:1; cursor:pointer; display:grid; place-items:center; padding:0; box-shadow:0 10px 24px rgba(16,25,21,.10); z-index:10;\n}\n.video-wrap { position:relative; overflow:hidden; border-radius:18px; background:#000; aspect-ratio:9/16; margin:0 auto; width:min(348px, calc(70vh * 9 / 16)); max-width:100%; }\n.video-wrap video { width:100%; height:100%; display:block; object-fit:cover; }\n.video-note { margin:8px 4px 0; text-align:center; font-size:12px; line-height:1.45; color:#40524A; }\n.audio-tip { display:block; margin-top:2px; font-size:11px; color:rgba(19,35,29,.52); }\n\n.video-overlay { position:absolute; inset:0; display:flex; align-items:center; justify-content:center; background:linear-gradient(to top, rgba(19,35,29,.18), rgba(19,35,29,0) 42%); pointer-events:auto; }\n.play-btn { width:58px; height:58px; border:none; border-radius:999px; background:rgba(247,245,241,.92); box-shadow:0 10px 24px rgba(16,25,21,.14); display:grid; place-items:center; cursor:pointer; pointer-events:auto; }\n.play-btn:before { content:\"\"; margin-left:3px; border-left:15px solid var(--primary-dark); border-top:9px solid transparent; border-bottom:9px solid transparent; }\n\n.video-controls { position:absolute; left:12px; right:12px; bottom:12px; display:flex; align-items:center; gap:10px; padding:10px 12px; border-radius:14px; background:rgba(19,35,29,.58); backdrop-filter:blur(8px); }\n.ctrl-btn { width:30px; height:30px; border:none; border-radius:999px; background:rgba(255,255,255,.12); color:#fff; display:grid; place-items:center; cursor:pointer; padding:0; flex:0 0 30px; }\n.ctrl-btn.playing::before { content:\"❚❚\"; font-size:11px; letter-spacing:-2px; }\n.ctrl-btn.paused::before { content:\"▶\"; font-size:13px; margin-left:2px; }\n.ctrl-btn.volume-on::before { content:\"🔊\"; font-size:13px; }\n.ctrl-btn.volume-off::before { content:\"🔇\"; font-size:13px; }\n\n.progress-range, .volume-range { -webkit-appearance:none; appearance:none; height:4px; border-radius:999px; background:rgba(255,255,255,.28); outline:none; min-width: 0; }\n.progress-range { flex:1; }\n.volume-range { width:72px; max-width: 30%; }\n.progress-range::-webkit-slider-thumb, .volume-range::-webkit-slider-thumb { -webkit-appearance:none; appearance:none; width:12px; height:12px; border-radius:999px; background:#fff; cursor:pointer; }\n.progress-range::-moz-range-thumb, .volume-range::-moz-range-thumb { width:12px; height:12px; border:none; border-radius:999px; background:#fff; cursor:pointer; }\n\n@media (max-width:1120px){\n  .example-grid { grid-template-columns:1fr; gap:24px; }\n  .welcome-pane { justify-content:flex-start; }\n  .welcome-copy { width:min(520px,100%); }\n  .welcome-copy h2 { font-size:48px; }\n  .form-card { max-width:440px; margin: 0 auto; }\n}\n@media (max-width:760px){\n  .welcome-page-container { padding:56px 16px 24px; }\n  .welcome-copy h2 { font-size:38px; }\n  .welcome-copy p { font-size:16px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"welcome-page-container": `WelcomeOnboardingPage_welcome-page-container__Uuj8Q`,
	"utility-bar": `WelcomeOnboardingPage_utility-bar__BQom+`,
	"back": `WelcomeOnboardingPage_back__Db7aA`,
	"example-shell": `WelcomeOnboardingPage_example-shell__LmyiN`,
	"example-grid": `WelcomeOnboardingPage_example-grid__51pQQ`,
	"welcome-pane": `WelcomeOnboardingPage_welcome-pane__Ezwm0`,
	"welcome-copy": `WelcomeOnboardingPage_welcome-copy__zlz5d`,
	"welcome-logo": `WelcomeOnboardingPage_welcome-logo__dYV8E`,
	"eyebrow": `WelcomeOnboardingPage_eyebrow__dahyS`,
	"steps": `WelcomeOnboardingPage_steps__tqJVN`,
	"step": `WelcomeOnboardingPage_step__Rm-yK`,
	"n": `WelcomeOnboardingPage_n__nyRH1`,
	"replay-link": `WelcomeOnboardingPage_replay-link__nfkRm`,
	"form-card": `WelcomeOnboardingPage_form-card__7ctJF`,
	"tabs": `WelcomeOnboardingPage_tabs__5XiJ6`,
	"tab": `WelcomeOnboardingPage_tab__7z2Qn`,
	"active": `WelcomeOnboardingPage_active__iF8il`,
	"fields": `WelcomeOnboardingPage_fields__pw+aZ`,
	"field": `WelcomeOnboardingPage_field__WNc6t`,
	"switch-field": `WelcomeOnboardingPage_switch-field__agH10`,
	"field-input": `WelcomeOnboardingPage_field-input__m3EqP`,
	"field-disabled": `WelcomeOnboardingPage_field-disabled__kjB1w`,
	"switch": `WelcomeOnboardingPage_switch__IqSvD`,
	"switch-on": `WelcomeOnboardingPage_switch-on__mbR52`,
	"checks": `WelcomeOnboardingPage_checks__aO3lg`,
	"check": `WelcomeOnboardingPage_check__LQlqL`,
	"box": `WelcomeOnboardingPage_box__ZhzSW`,
	"box-checked": `WelcomeOnboardingPage_box-checked__Yvy4T`,
	"legal-note": `WelcomeOnboardingPage_legal-note__4XIEY`,
	"primary": `WelcomeOnboardingPage_primary__av2tH`,
	"google": `WelcomeOnboardingPage_google__55nR-`,
	"divider": `WelcomeOnboardingPage_divider__6dD7O`,
	"gmark": `WelcomeOnboardingPage_gmark__Pr92z`,
	"go-home": `WelcomeOnboardingPage_go-home__ePd97`,
	"video-modal": `WelcomeOnboardingPage_video-modal__wKZju`,
	"video-card": `WelcomeOnboardingPage_video-card__jpP56`,
	"video-top": `WelcomeOnboardingPage_video-top__du3+g`,
	"close-video": `WelcomeOnboardingPage_close-video__7LfLX`,
	"video-wrap": `WelcomeOnboardingPage_video-wrap__ie1mJ`,
	"video-note": `WelcomeOnboardingPage_video-note__x4AVx`,
	"audio-tip": `WelcomeOnboardingPage_audio-tip__NUlK8`,
	"video-overlay": `WelcomeOnboardingPage_video-overlay__N2uVO`,
	"play-btn": `WelcomeOnboardingPage_play-btn__q4amT`,
	"video-controls": `WelcomeOnboardingPage_video-controls__mwjZ6`,
	"ctrl-btn": `WelcomeOnboardingPage_ctrl-btn__OVkps`,
	"playing": `WelcomeOnboardingPage_playing__hvSEL`,
	"paused": `WelcomeOnboardingPage_paused__WK8RF`,
	"volume-on": `WelcomeOnboardingPage_volume-on__bQGLP`,
	"volume-off": `WelcomeOnboardingPage_volume-off__DnZbF`,
	"progress-range": `WelcomeOnboardingPage_progress-range__Tzt1U`,
	"volume-range": `WelcomeOnboardingPage_volume-range__CQ4QB`
};
export default ___CSS_LOADER_EXPORT___;
